"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// Shared sticky header for every get-in-touch sidesheet step (the connect
// form, the survey, and the review sheet): back arrow, a title, and an
// optional right-side action (e.g. the survey's "Skip" link).
export default function GetInTouchHeader(t0) {
  const $ = _c(16);
  const {
    title,
    onBack,
    rightSlot,
    className: t1,
    bgVar: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const bgVar = t2 === undefined ? "--colorSurfaceSurface" : t2;
  const router = useRouter();
  let t3;
  if ($[0] !== onBack || $[1] !== router) {
    t3 = onBack || (() => router.back());
    $[0] = onBack;
    $[1] = router;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleBack = t3;
  const t4 = `sticky top-0 z-10 flex items-center gap-1 px-1 py-4 ${className}`;
  const t5 = `var(${bgVar})`;
  let t6;
  if ($[3] !== t5) {
    t6 = {
      backgroundColor: t5
    };
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ArrowBackIcon sx={{
      color: "var(--textPrimaryPrimary)"
    }} />;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== handleBack) {
    t8 = <IconButton onClick={handleBack} aria-label="Go back" className="!ml-0">{t7}</IconButton>;
    $[6] = handleBack;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== title) {
    t9 = <h1 className="m3-title-large flex-1 text-[--textPrimaryPrimary]">{title}</h1>;
    $[8] = title;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== rightSlot || $[11] !== t4 || $[12] !== t6 || $[13] !== t8 || $[14] !== t9) {
    t10 = <div className={t4} style={t6}>{t8}{t9}{rightSlot}</div>;
    $[10] = rightSlot;
    $[11] = t4;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}